module.exports = __webpack_public_path__ + "static/media/support-staff.915ca889.svg";